export enum WebhookEventType {
  PRODUCT_CREATED = "product.created",
  PRODUCT_UPDATED = "product.updated",
  PRODUCT_DELETED = "product.deleted",
  SALE_COMPLETED = "sale.completed",
  PING = "ping",
}

export const SUBSCRIBABLE_WEBHOOK_EVENT_TYPES = [
  WebhookEventType.PRODUCT_CREATED,
  WebhookEventType.PRODUCT_UPDATED,
  WebhookEventType.PRODUCT_DELETED,
  WebhookEventType.SALE_COMPLETED,
] as const;
